import { render, staticRenderFns } from "./rename.vue?vue&type=template&id=35fdf421&scoped=true"
import script from "./rename.vue?vue&type=script&lang=js"
export * from "./rename.vue?vue&type=script&lang=js"
import style0 from "./rename.vue?vue&type=style&index=0&id=35fdf421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fdf421",
  null
  
)

export default component.exports